import { render, staticRenderFns } from "./PainelOuvidoria.vue?vue&type=template&id=e226fd16"
import script from "./PainelOuvidoria.vue?vue&type=script&lang=js"
export * from "./PainelOuvidoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports